export enum LessonType {
  Lecture = "LECTURE",
  Quiz = "QUIZ",
  Text = "TEXT",
  Task = "TASK",
  Oral = "ORAL",
  // Test = "TEST"
}

export enum LessonTypeRU {
  Lecture = "Лекция",
  Homework = "Домашнее задание",
  Quiz = "Тест",
  WorkOnMistakes = "Работа над ошибками",
  Text = "Текстовый урок",
  Task = "Задание",
  Oral = "Сабақ тапсыру",
  // Quiz = 'Опрос'
}

export enum LessonTypeKZ {
  Lecture = "Лекция",
  Homework = "Үй жұмысы",
  Quiz = "Тест",
  WorkOnMistakes = "Қатемен жұмыс",
  Text = "Мәтіндік материал",
  Task = "Тапсырма",
  Oral = "Сабақ тапсыру",
}

export enum DiffucltLevel {
  A = "A",
  B = "B",
  C = "C"
}

export enum TestType {
  Test = "TEST",
  Open = "OPEN",
  DragAndDrop = "DRAG_AND_DROP",
  Fill = "FILL",
  Matching = "MATCHING",
  Multidropdown = "MULTI_DROPDOWN"
}

export type EntQuestionsType = 'TEST' | 'SINGLE' | 'MULTIPLE' | 'MULTI_DROPDOWN' | 'CONTEXT';
export const EntQuestionTypes: Record<EntQuestionsType, EntQuestionsType> = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
  MULTI_DROPDOWN: 'MULTI_DROPDOWN',
  CONTEXT: 'CONTEXT',
  TEST: 'TEST',
} as const;

export enum TestTypeKz {
  Test = "Дұрыс жауапты таңдау",
  Open = "Ашық жауап",
  DragAndDrop = "Сөздерді мәтінге жылжыту",
  Fill = "Жетіспейтін сөздерді енгізу",
  Matching = "Сәйкестік",
  Multidropdown = "Тізімнен таңдау"
}

export enum TestTypeRu {
  Test = "Выбор правильного ответа",
  Open = "Открытый ответ",
  DragAndDrop = "Перетаскивание слов в текст",
  Fill = "Ввод пропущенных слов",
  Matching = "Соответствие",
  Multidropdown = "Выбор из списка"
}

export enum CuratorTasksType {
  CheckedTasks = 'checkedTasks',
  NotCheckedTasks = 'notCheckedTasks'
}

export enum StudentTasksType {
  Assigned = 'ASSIGNED',
  Expired = 'EXPIRED',
  OnChecking = 'ON_CHECKING',
  Done = 'DONE'
}

export enum StudentDeadlinesEnum {
  DoneThisWeek = 'DONE_THIS_WEEK',
  DoneNextWeek = 'DONE_NEXT_WEEK',
  DoneLater = 'DONE_LATER',
  ExpiredThisWeek = 'EXPIRED_THIS_WEEK',
  ExpiredNextWeek = 'EXPIRED_NEXT_WEEK',
  ExpiredLater = 'EXPIRED_LATER',
  AssignedThisWeek = 'ASSIGNED_THIS_WEEK',
  AssignedNextWeek = 'ASSIGNED_NEXT_WEEK',
  AssignedLater = 'ASSIGNED_LATER',
  InReviewLater = 'IN_REVIEW_LATER',
  InReviewNextWeek = 'IN_REVIEW_NEXT_WEEK',
  InReviewThisWeek = 'IN_REVIEW_THIS_WEEK'
}
